var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4002_96182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1367 41.6406V52.8948",
    stroke: "white",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8818 52.8945H39.3901",
    stroke: "white",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6411 23.6324H40.3924C41.1658 22.3036 41.6411 20.7791 41.6411 19.1308C41.6411 14.1583 37.6103 10.1275 32.6378 10.1275C32.5994 10.1275 32.5639 10.1383 32.5256 10.1387C31.9802 6.32041 28.7291 3.375 24.7599 3.375C20.4091 3.375 16.8821 6.90209 16.8821 11.2529C16.8821 12.0169 17.0251 12.7407 17.228 13.4393C14.3591 14.9446 12.3804 17.9169 12.3804 21.3816C12.3804 22.2372 12.5379 23.0484 12.7608 23.8326C8.68709 24.6944 5.62793 28.3054 5.62793 32.6357C5.62793 37.608 9.65877 41.639 14.6312 41.639H41.6411C46.6136 41.639 50.6444 37.608 50.6444 32.6357C50.6444 27.6633 46.6136 23.6324 41.6411 23.6324Z",
    stroke: "white",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4002_96182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.0198,
    height: 54.0198,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.59a05e87a3d92bfc1297390368eb9535.svg";
export { ForwardRef as ReactComponent };